<script lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useDesignStore } from '../../../../stores/designStore.ts'

export default {
  props: ['name'],
  setup(props, context) {
    const nameBanner = ref(props?.name || '')
    const router = useRouter()
    const designStore = useDesignStore()
    return { designStore, nameBanner, props }
  },

  methods: {},
  components: {}
}
</script>

<template>
  <div style="position: absolute">
    <v-icon
      name="gi-vertical-banner"
      scale="12"
      :style="{ color: designStore.primaryTheme }"
    ></v-icon>
    <v-icon
      scale="2.75"
      :name="props?.name"
      :style="{ color: designStore.secondaryTheme }"
      style="position: absolute; top: 5rem; left: 5.55rem"
    ></v-icon>
  </div>
</template>

<style></style>
